import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=8b117180&"
import script from "./ActionButton.vue?vue&type=script&lang=ts&"
export * from "./ActionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b117180')) {
      api.createRecord('8b117180', component.options)
    } else {
      api.reload('8b117180', component.options)
    }
    module.hot.accept("./ActionButton.vue?vue&type=template&id=8b117180&", function () {
      api.rerender('8b117180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/src/components/ActionButton.vue"
export default component.exports